export default "__VITE_ASSET__CXp1wrB0__"